<div class="card-view-primary-box app-scrollbar">
  <div class="header row align-items-center">
    <div class="col-11 d-flex align-items-end">
      <div class="col-12 d-flex align-items-center">
        <img src="assets/svg/icon-key-circle.svg" alt="key icon" />
        <span class="count pr-10 pl-12">
          {{ availableUnit?.totalCount }}
        </span>

        <div class="dashboard-card-header">
          {{ 'AVAILABLE_UNITS' | translate }}
        </div>
      </div>
    </div>
    <hr class="col-12 divider" />
  </div>

  <div class="content position-relative">
    <ng-container *ngIf="availableUnit?.units?.length === 0">
      <p class="no-record">
        {{ 'RECORD_NOT_FOUND' | translate }}
      </p>
    </ng-container>
    <ng-container *ngIf="availableUnit?.units?.length > 0">
      <div
        class="main-containter"
        *ngFor="
          let unitData of availableUnit?.units | sortBy : 'unitName' : 'asc';
          let i = index;
          trackBy: trackByOption
        "
      >
        <a class="user-item">
          <div class="row py-2 mx-2 item pointer-cursor">
            <div class="col-8">
              <div class="col-12 dashboard-list-content">
                <app-with-tooltip [showHelpCursor]="true">
                  {{ 'UNIT' | translate }}
                  {{
                    unitData?.unitPrefix + unitData?.unitName
                  }}</app-with-tooltip
                >
              </div>
              <div class="col-12 status">
                <app-with-tooltip [showHelpCursor]="true">
                  {{ unitData?.buildingName }}</app-with-tooltip
                >
              </div>
            </div>
            <div
              class="col-4 px-1 text-right align-self-center"
              (click)="onClickAvailableUnit(unitData)"
            >
              <span class="time">
                {{
                  unitData?.unitStatus
                    ? (unitData?.unitStatus | titlecase)
                    : ("NOT_AVAILABLE" | translate)
                }}
              </span>
              <img src="assets/svg/ico-chevron-forward-outline.svg" />
            </div>
          </div>
        </a>
      </div>
    </ng-container>
  </div>

  <a
    class="view-all-btn d-flex justify-content-center align-items-center "
    [ngClass]="
      availableUnit?.totalCount > dashboardManagementService.maxCardRecords
        ? 'visible'
        : 'invisible'
    "
    
  >
    <p 
    (click)="viewAllAvailableUnits()"
    class="mt-1 mb-0 pointer-cursor">{{ 'VIEW_ALL' | translate }}</p>
  </a>
</div>
